import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { Stack } from '@mui/material';
import { Grid2 } from '@aibees/shared/components';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentReportProps as Props } from './types';
import { EnrichmentNavigateHeader } from './components/enrichment-navigate-header';
import { EnrichmentGeneralOverviewResults } from './components/enrichment-general-overview-results';
import { EnrichmentFileManagement } from './components/enrichment-file-management';
import { EnrichedResultItem } from './components/enriched-result-item';

export const EnrichmentReport = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('EnrichmentReport', className)}
      sx={SX.root}
    >
      <EnrichmentNavigateHeader />
      <Stack sx={SX.content}>
        <Grid2 container columns={48} spacing={1.5}>
          <Grid2 xs={37}>
            <EnrichmentGeneralOverviewResults />
          </Grid2>
          <Grid2 xs={11}>
            <EnrichmentFileManagement />
          </Grid2>
          <Grid2 xs={48}>
            <EnrichedResultItem title="AI Analysis" />
          </Grid2>
          <Grid2 xs={48}>
            <EnrichedResultItem title="Email" />
          </Grid2>
          <Grid2 xs={48}>
            <EnrichedResultItem title="Phone" />
          </Grid2>
        </Grid2>
      </Stack>
    </Styled.Wrapper>
  );
});

EnrichmentReport.displayName = 'EnrichmentReport';
